import React ,{useState, useEffect} from 'react'
//Bibliotecas
import styled from 'styled-components'
//Componentes
import FlexContainer from '../../components/common/FlexContainer'
import OvaCards from './components/OvaCards'
//Imágenes
import asideImage from  '../../assets/images/Saly-38.png'
//Servicios
import OvaService from '../../services/OvaService'

export default function EstudianteHome() {
  //Estados 
  const [ovas, setOvas] = useState([]);
  //Manipuladores
  useEffect(() => {
    OvaService.obtenerOvas().then(res=>{
      setOvas(res.Respuesta)
    })
    return () => {
    }
  }, [])

  return (
    <FlexContainer flexDirection='row' justifyContent='space-between' backgroundColor='transparent' minHeight='100vh'>
        <Image src={asideImage}></Image>
        <OvaCards ovas={ovas}></OvaCards>
    </FlexContainer>
  )
}

const Image = styled.img`
    width: 40%;
`;
